export default __webpack_public_path__ + "static/107978-6d24819263c825b1ecd64bcdcbbbf352.jpg";